import * as R from "ramda";

import { ProductType } from "../specs/product";
import type { Brand } from "../types/brand";

import type { LabelMapEntry } from "./map-possible-values";

export const getBrandsLabelMap = (activeBrands: Brand[]): LabelMapEntry[] => {
  return activeBrands.map(
    brand =>
      ({
        key: brand.key,
        label: brand.displayName
      }) satisfies LabelMapEntry
  );
};

export const sortBrandsAlphabetically = <Type extends { key: string }>(brands: Type[]): Type[] =>
  R.sortBy(({ key }) => key, brands);

/**
 * Ensure that all `availableModelYears` for a Brand are handled.
 * `availableModelYears` which are not declared as active- or inactive, are put into the `inactiveModelYears` array.
 */
export const ensureAllAvailableModelYearsHandled = <Type extends ProductType = ProductType>(
  brand: Brand<Type>
): Brand<Type> => {
  const availableModelYears = brand.availableModelYears ?? [];
  const modelYears = brand.modelYears ?? [];
  const inactiveModelYears = brand.inactiveModelYears ?? [];

  const isUnhandled = (modelYear: number) => !modelYears.includes(modelYear) && !inactiveModelYears.includes(modelYear);

  const unhandledModelYears: number[] = availableModelYears.filter(isUnhandled);

  return {
    ...brand,
    modelYears,
    inactiveModelYears: [...inactiveModelYears, ...unhandledModelYears]
  };
};
